import type { AgentBuildProgressEvent } from '@travel-planner/shared/schemas';
import { pickCss } from '@/shared/lib/css-utils';
import { Text } from '@/shared/ui';
import css from './agent-build-progress.module.scss';

const rootCss = pickCss(css, css.root);

export type AgentBuildProgressProps = {
  event: AgentBuildProgressEvent;
};

// Coarse build-progress indicator for long multi-step builds (P2.7) — renders
// a "Day 3 of 7" label + a fill bar in place of the flat spinner. Latest-wins:
// the run hook keeps only the most recent beat, so this always shows where the
// build is now. `phase` (when present) prefixes the count ("Adding day 3 of 7").
export const AgentBuildProgress = ({ event }: AgentBuildProgressProps) => {
  const { completed, total, phase } = event;
  // `total` is schema-guaranteed positive; clamp the ratio so a completed count
  // that briefly overshoots can't push the bar past 100%.
  const ratio = Math.min(1, Math.max(0, completed / total));
  const label = `${phase ? `${phase} — ` : ''}${completed} of ${total}`;

  return (
    <div className={rootCss()} role="status" aria-live="polite">
      <Text as="span" size="sm">
        {label}
      </Text>
      <div className={css.track} aria-hidden="true">
        <div
          className={css.fill}
          style={{ inlineSize: `${Math.round(ratio * 100)}%` }}
        />
      </div>
    </div>
  );
};
